import { Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import styles from "../add.module.css";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useState } from "react";
import { useEffect } from "react";
import ProductComponent from "./ProductComponent";
import { authCustomerData } from "../../../../admin/components/GetAuth";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";

const Step1 = ({ saveStep1Data, bookingData, freightType, setFreightGateOpen }) => {
  const [isRegCompany, setIsRegCompany] = useState("");
  const [noOfItems, setNoOfItems] = useState(0);
  const VATCharge = 0;
  const InsuranceCharge = 0;
  const [itemTotal, setItemTotal] = useState(0);
  const [allTotal, setAllTotal] = useState(0);
  const [discountVal, setDiscountVal] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [referralAmount, setReferralAmount] = useState(0);
  const [referralDiscount, setReferralDiscount] = useState(0);

  const { register, handleSubmit, control, formState: { errors }, setValue, clearErrors, watch, getValues } = useForm({
    mode: "onChange",
    defaultValues: {
      registered_company: "",
      company_shipping: "",
      company_name: "",
      insurance: "",
      pickup_date: dayjs(),
      notes: "",
      products: bookingData?.products ? bookingData?.products : [{ category_id: "", item_id: "", item_name: "", total: "", is_fragile: false, is_item: true, weight: "" }]
    }
  });

  const { fields: fileds2, append: append2, remove: remove2, replace: replace2 } = useFieldArray({
    control,
    name: "products",
  });

  useEffect(() => {
    if (authCustomerData() && !bookingData) {
      setValue(`registered_company`, authCustomerData()?.registered_company);
      setIsRegCompany(authCustomerData()?.registered_company);

      if (authCustomerData()?.registered_company === "Yes") {
        setValue(`company_name`, authCustomerData()?.company_name);
        setValue(`company_shipping`, authCustomerData()?.company_shipping);
      }

      setReferralAmount(authCustomerData()?.referral_amount);

      if (authCustomerData()?.membership_discount) {
        setDiscountVal(parseFloat(authCustomerData()?.membership_discount));
      }
    }
    if (bookingData) {
      setDiscountVal(bookingData?.discountVal);

      let discountTemp = 0;
      let discountTemp2 = 0;

      if (typeof (bookingData?.discountAmount) !== 'undefined') {
        setDiscountAmount(bookingData?.discountAmount);
        discountTemp = bookingData?.discountAmount;
      }

      if (typeof (bookingData?.referralDiscount) !== 'undefined') {
        setReferralDiscount(bookingData?.referralDiscount);
        discountTemp2 = bookingData?.referralDiscount;
      }

      setValue(`customer_id`, bookingData?.customer_id);
      setValue(`registered_company`, bookingData?.registered_company);
      setValue(`insurance`, bookingData?.insurance);
      setValue(`notes`, bookingData?.notes);
      setValue(`pickup_date`, dayjs(bookingData?.pickup_date));

      if (bookingData?.registered_company === "Yes") {
        setValue(`company_name`, bookingData?.company_name);
        setValue(`company_shipping`, bookingData?.company_shipping);
      }
      setIsRegCompany(bookingData?.registered_company);

      let allTotalTemp = 0;

      if (bookingData?.products) {
        let noOfI = 0;
        let itemT = 0;
        bookingData?.products.forEach((i) => {
          if (i?.total !== "") {
            noOfI++;
            itemT += parseFloat(i?.total);
          }
        });
        setNoOfItems(noOfI);
        setItemTotal(itemT);
        allTotalTemp += itemT;

        replace2(bookingData?.products);
      }

      setAllTotal(allTotalTemp + VATCharge + InsuranceCharge - discountTemp - discountTemp2);
    }
  }, [bookingData, replace2, setValue]);

  const cngProductVal = () => {
    let products = getValues("products");
    let noOfI = 0;
    let itemT = 0;
    let discountTemp = 0;
    let discountTemp2 = 0;
    products.forEach((i) => {
      if (i?.total !== "") {
        noOfI++;
        itemT += parseFloat(i?.total);
      }
    });
    setNoOfItems(noOfI);
    setItemTotal(itemT);
    if (discountVal) {
      discountTemp = ((itemT * discountVal) / 100);
      if (discountTemp > parseInt(discountTemp)) {
        discountTemp = discountTemp.toFixed(2);
        discountTemp = parseFloat(discountTemp);
      }
      setDiscountAmount(discountTemp);
    }

    if (referralAmount) {
      var subtotaltemp = itemT - discountTemp;
      if (subtotaltemp >= referralAmount) {
        discountTemp2 = referralAmount;
      } else {
        discountTemp2 = subtotaltemp;
      }
      setReferralDiscount(discountTemp2);
    }

    setAllTotal(itemT + VATCharge + InsuranceCharge - discountTemp - discountTemp2);
  }

  const calculateDimension = (index) => {
    const length = parseFloat(getValues(`products[${index}].length`)) || 0;
    const width = parseFloat(getValues(`products[${index}].width`)) || 0;
    const height = parseFloat(getValues(`products[${index}].height`)) || 0;

    if (length && width && height) {
      let estVal = (((((length * width * height) / 1000000) + 0.03) / 0.275) * 90);
      estVal = estVal.toFixed(2);
      estVal = parseFloat(estVal);

      setValue(`products[${index}].total`, estVal);
    } else {
      setValue(`products[${index}].total`, 0);
    }

    cngProductVal();
  };

  const delItems = (index) => {
    if (fileds2.length <= 1) return false;
    remove2(index);
    cngProductVal();
  }

  const onSubmit = (data) => {
    document.documentElement.scrollTo({ top: 0, left: 0, behavior: "instant" });

    // FIX: "Other" items are identified by item_id === 0 (matches admin booking flow
    // and the backend's expectations), not category_id === 0. category_id === -1 is
    // reserved for dimension-based custom items and must not be confused with this check.
    let pListTemp = data?.products?.map(i => {
      if (i?.item_id === 0 && i?.item_name && !String(i?.item_name).startsWith('Other- ')) {
        return { ...i, item_name: 'Other- ' + i?.item_name };
      }
      return i;
    });

    data = { ...data, freight_type: freightType, products: pListTemp, pickup_date: dayjs(data?.pickup_date).format("YYYY-MM-DD"), itemTotal: itemTotal, discountVal: discountVal, discountAmount: discountAmount, referralDiscount: referralDiscount };

    saveStep1Data(data);
  }

  return (<>
    <div className={`${styles.StepOneForm}`}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div>
            <button type="button" className={styles.FreightSummaryChip} onClick={() => setFreightGateOpen(true)}>
              {freightType === 'Air Freight' ? <FlightTakeoffIcon /> : <DirectionsBoatIcon />}
              {freightType || 'Select Freight Option'}
            </button>
            <div className={styles.FormSection}>
              <p className={styles.SectionLabel}>Shipper details</p>
              <div className={`${styles.StepOneFormFull}`}>
                <div className={styles.FormHalfGroup}>
                  <FormControl fullWidth>
                    <InputLabel>Do you have a registered company in UK?</InputLabel>
                    <Controller
                      control={control}
                      {...register("registered_company")}
                      render={({ field }) => (<Select
                        label="Do you have a registered company in UK?"
                        {...field}
                        onChange={(e) => {
                          field.onChange(e);
                          setIsRegCompany(e.target.value);
                        }}
                      >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </Select>)}
                    />
                  </FormControl>
                </div>
                {isRegCompany === "Yes" && (<>
                  <div className={styles.FormHalfGroup}>
                    <Controller
                      control={control}
                      {...register("company_name", { required: "This field is Required" })}
                      render={({ field }) => (<TextField {...field} label="If Yes, please mention the name of the company?*" variant="outlined" />)}
                    />
                    {errors.company_name && (<span className={styles.ErrorM}>{errors?.company_name?.message}</span>)}
                  </div>
                  <div className={styles.FormHalfGroup}>
                    <FormControl fullWidth>
                      <InputLabel>If Yes, are you shipping the goods in the name of the company?*</InputLabel>
                      <Controller
                        control={control}
                        {...register("company_shipping", {
                          required: "Please select one",
                        })}
                        render={({ field }) => (<Select label="If Yes, are you shipping the goods in the name of the company?*" {...field}>
                          <MenuItem value="Yes">Yes</MenuItem>
                          <MenuItem value="No">No</MenuItem>
                        </Select>)}
                      />
                    </FormControl>
                    {errors.company_shipping && (<span className={styles.ErrorM}>{errors?.company_shipping?.message}</span>)}
                  </div>
                </>
                )}
                <div className={styles.FormHalfGroup}>
                  <FormControl fullWidth>
                    <InputLabel>Have you got insurance?</InputLabel>
                    <Controller
                      control={control}
                      {...register("insurance")}
                      render={({ field }) => (<Select {...field} label="Have you got insurance?">
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                        <MenuItem value="Not Interested">Not Interested</MenuItem>
                      </Select>)}
                    />
                  </FormControl>
                </div>
              </div>
            </div>

            <div className={styles.FormSection}>
              <p className={styles.SectionLabel}>Items</p>

              <ProductComponent
                fields={fileds2}
                append={append2.bind(this)}
                errors={errors}
                control={control}
                setValue={setValue.bind(this)}
                register={register}
                clearErrors={clearErrors.bind(this)}
                watch={watch.bind(this)}
                getValues={getValues.bind(this)}
                cngProductVal={cngProductVal.bind(this)}
                delItems={delItems.bind(this)}
                calculateDimension={calculateDimension.bind(this)}
                freightType={freightType}
              />
            </div>

            <div className={styles.FormSection}>
              <p className={styles.SectionLabel}>Schedule &amp; summary</p>
              <div className={`${styles.StepOneFormFull}`}>
                <div className={`${styles.StepOneFormSmall} ${styles.StepOneFormSmallNew1}`}>
                  <div className={styles.FormHalfGroup} style={{ width: '100%' }}>
                    <Controller
                      control={control}
                      {...register("pickup_date", { required: "Please select pick up date" })}
                      render={({ field }) => (<DatePicker
                        {...field}
                        minDate={dayjs()}
                        label="Pickup Date"
                        format="DD/MM/YYYY"
                      />)}
                    />
                    {errors.pickup_date && (<span className={styles.ErrorM}>{errors?.pickup_date?.message}</span>)}
                  </div>
                  <div>
                    <div className={styles.FormHalfGroup} style={{ width: '100%' }}>
                      <Controller
                        control={control}
                        {...register("notes")}
                        render={({ field }) => (<TextField {...field} label="Booking Notes" variant="outlined" multiline rows={4} />)}
                      />
                    </div>
                  </div>
                  <div>
                    <FormControlLabel
                      className={styles.CheckBox}
                      label="I have read and agree to the prohibited & restricted items list*"
                      control={<Checkbox {...register("is_accept", { required: true })} />}
                    />
                    {errors?.is_accept && (<p className={styles.ErrorM}>Please accept terms & condition</p>)}
                  </div>
                </div>
                <div className={`${styles.StepOneFormSmall} ${styles.StepOneFormSmallNew2}`}>
                  <ul className={`${styles.CostUL}`}>
                    <li>
                      <p className={`${styles.CostTitle}`}>No of Items:</p>
                      <p className={`${styles.CostNo}`}>{noOfItems}</p>
                    </li>
                    <li>
                      <p className={`${styles.CostTitle}`}>Item Subtotal:</p>
                      <p className={`${styles.CostNo}`}>
                        £{itemTotal?.toFixed(2)}
                      </p>
                    </li>
                    {discountVal > 0 && <li>
                      <p className={`${styles.CostTitle}`}>Membership Discount({discountVal}%):</p>
                      <p className={`${styles.CostNo}`}>-£{discountAmount.toFixed(2)}</p>
                    </li>}
                    {referralDiscount > 0 && <li>
                      <p className={`${styles.CostTitle}`}>Referral Discount:</p>
                      <p className={`${styles.CostNo}`}>-£{referralDiscount.toFixed(2)}</p>
                    </li>}
                    <li>
                      <p className={`${styles.CostTitle}`}>Total VAT:</p>
                      <p className={`${styles.CostNo}`}>£0.00</p>
                    </li>
                    <li>
                      <p className={`${styles.CostTitle}`}>Insurance Charges:</p>
                      <p className={`${styles.CostNo}`}>£0.00</p>
                    </li>
                    <li>
                      <p className={`${styles.CostTitle} ${styles.Big}`}>Total:</p>
                      <p className={`${styles.CostNo} ${styles.Big}`}>£{allTotal?.toFixed(2)}</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className={`${styles.StepBUSec}`}>
              <button className={`${styles.Next}`} type="submit">Next</button>
            </div>
          </div>
        </form>
      </LocalizationProvider>
    </div>
  </>);
}

export default Step1;